"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[5383],{

/***/ 5383:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ clickToggle)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * @description
 * * Toggles the 'active' class on a given element on click
 * * Multiple triggers can toggle the active class on a single target
 *
 * @options HTML data properties on "wrapper" element
 * * [data-utility="click-toggle"] { required } - Wrapper element that runs this code
 * * [data-toggle] {required} - Pass query selector for target element
 */

function clickToggle({ wrapper }) {
  const selectors = {
    target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle'),
    triggers: `[data-toggle="${jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle')}"]`,
  }

  const cache = {
    $targets: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.target),
    $triggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.triggers),
  }

  // TailwindCSS variants representing different states
  const { classes } = window.config

  const settings = {
    class: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('class') || classes.active,
  }

    // Initialize
    ; (function initEventListeners() {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click.clickToggle.toggle', toggle)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('toggle:close', close)
    })()

  function toggle() {
    const isActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)

    cache.$targets.toggleClass(settings.class, !isActive)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.triggers).toggleClass(classes.active, !isActive)
  }

  function close() {
    cache.$targets.removeClass(settings.class)
    cache.$triggers.removeClass(classes.active)
  }
}


/***/ })

}]);